<template>
  <v-footer
    class="justify-center"
    color="transparent"
  >
    <p class="text-center text-overline">
      Copyright {{ year }}. All right reserved.
    </p>
  </v-footer>
</template>

<script>
export default {
  name: 'FooterLayout',
  created() {
    this.year = new Date().getFullYear();
  },
  data() {
    return {
      year: '',
    }
  },
}
</script>
